import React, { useEffect, useState } from "react";
import "./Add_offcanvas.css";
import Select from "react-select";
import { Button, Form, Offcanvas } from "react-bootstrap";
import Blue_border_button from "../../../../../../common_components/common_btn/blue_border_button/Blue_border_button";
import Success_modal from "../../../../../../common_components/common_modal/success_modal/Success_modal";
import successAnimation from "../../../../../../animation/success_lottie/Success_lottie.json";
import classNames from "classnames";
import { Controller, useForm, useFieldArray } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  Create,
  GetAll,
} from "../../../../../../../features/admin/internship/internship/Slice";
import { IDS } from "../../../../../../../utils/IDS";
import {
  allDocument,
  allRequirement,
  allAccomodation,
} from "../../../../../../../features/admin/common/Slice";

function Add_offcanvas({
  setShow,
  setSuccess,
  setShowError,
  defaultValues = {},
  showError,
  show,
  handleClose,
  setShowRejectModal,
  image_required = true,
  logo_required = true,
  country_logo_required = true,
}) {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    control,
    getValues,
    formState: { errors },
  } = useForm({ defaultValues });

  const dispatch = useDispatch();

  const imageFile = watch("image");
  const logoFile = watch("logo");
  const countrylogoFile = watch("country_logo");
  const accomodationStatus = watch("accomodation_status"); // Yes/No for accommodation
  const startDate = watch("start_date");

  const internshipDocument = useSelector((state) => state.common.all_document);
  const internshipRequirement = useSelector(
    (state) => state.common.all_requirement,
  );

  useEffect(() => {
    dispatch(allDocument());
    dispatch(allRequirement());
    dispatch(allAccomodation());
  }, [dispatch]);

  const [modalSuccessShow, setModalsuccessShow] = useState(false);

  // Dynamic contacts
  const {
    fields: contactFields,
    append: appendContact,
    remove: removeContact,
  } = useFieldArray({
    control,
    name: "contacts",
  });

  useEffect(() => {
    if (startDate) {
      reset((prev) => ({
        ...prev,
        end_date: "",
      }));
    }
  }, [startDate]);

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();

      sendData.append("name", data.name?.trim() || "");
      sendData.append("title", data.title?.trim() || "");
      sendData.append("description", data.description?.trim() || "");
      sendData.append("address", data.address?.trim() || "");
      sendData.append("stipend", data.stipend || 0);
      sendData.append("start_date", data.start_date || "");
      sendData.append("end_date", data.end_date || "");
      sendData.append("work_hour", data.work_hour || "");
      sendData.append("vacancy", data.vacancy || 0);

      sendData.append(
        "accomodation_status",
        data.accomodation_status === "true",
      );
      sendData.append("meal_provided", data.meal_provided === "true");
      sendData.append("uniform_provided", data.uniform_provided === "true");
      sendData.append("laundry_service", data.laundry_service === "true");

      // Address fields (only if accommodation is true)
      if (data.accomodation_status === "true") {
        sendData.append("street", data.street?.trim() || "");
        sendData.append("postal_code", data.postal_code?.trim() || "");
        sendData.append("city", data.city?.trim() || "");
        sendData.append("country", data.country?.trim() || "");
      }

      // Files
      if (data.logo?.[0]) sendData.append("logo", data.logo[0]);
      if (data.image?.[0]) sendData.append("image", data.image[0]);
      if (data.country_logo?.[0])
        sendData.append("country_logo", data.country_logo[0]);

      // Multi-select: Requirements & Documents
      if (data.requirements) {
        data.requirements.forEach((item) =>
          sendData.append("requirement_ids[]", item.value),
        );
      }
      if (data.documents) {
        data.documents.forEach((item) =>
          sendData.append("document_ids[]", item.value),
        );
      }

      // Contacts → backend expects `position` field
      if (data.contacts && data.contacts.length > 0) {
        data.contacts.forEach((contact, index) => {
          sendData.append(`contacts[${index}][name]`, contact.name || "");
          sendData.append(`contacts[${index}][email]`, contact.email || "");
          sendData.append(
            `contacts[${index}][contact_no]`,
            contact.contact_no || "",
          );
          sendData.append(
            `contacts[${index}][position]`,
            contact.designation || "",
          );
        });
      }

      const res = await dispatch(Create(sendData));

      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(GetAll());
        setModalsuccessShow(true);
        reset();
        setShow(false);
        setSuccess(true);
      } else {
        setShowRejectModal(true);
      }
    } catch (error) {
      setShow(false);
      setShowRejectModal(true);
      console.error(error);
    }
  };
  const today = new Date().toISOString().split("T")[0];

  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        className="view_application_canvas common_offcanvas"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Add Internship</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="form_holder">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                {/* Basic Fields */}
                <div className="col-md-4 mb-3">
                  <Form.Group>
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Name"
                      {...register("name", { required: "Name is required" })}
                      className={classNames({ "is-invalid": errors.name })}
                    />
                    {errors.name && (
                      <Form.Text className="text-danger">
                        {errors.name.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group>
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Title"
                      {...register("title", { required: "Title is required" })}
                      className={classNames({ "is-invalid": errors.title })}
                    />
                    {errors.title && (
                      <Form.Text className="text-danger">
                        {errors.title.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group>
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Enter Description"
                      {...register("description", {
                        required: "Description is required",
                      })}
                      className={classNames({
                        "is-invalid": errors.description,
                      })}
                    />
                    {errors.description && (
                      <Form.Text className="text-danger">
                        {errors.description.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group>
                    <Form.Label>Address (General)</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter General Address"
                      {...register("address", {
                        required: "Address is required",
                      })}
                      className={classNames({ "is-invalid": errors.address })}
                    />
                    {errors.address && (
                      <Form.Text className="text-danger">
                        {errors.address.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3"></div>
                <div className="col-md-4 mb-3"></div>

                {/* File Uploads */}
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field"></Form.Group>
                  <Form.Label>Logo</Form.Label>
                  <Form.Control
                    className={classNames("", {
                      "is-invalid": errors?.logo,
                    })}
                    type="file"
                    {...register("logo", {
                      required: logo_required
                        ? "Logo is required"
                        : logo_required,
                      validate: async (value) => {
                        // if (typeof value !== "string") {
                        //   const fileTypes = ["jpg", "png", "jpeg"];
                        //   const fileType = value[0].name?.split(".")[1];
                        //   if (!fileTypes.includes(fileType)) {
                        //     return `please upload a valid file format. (${fileTypes})`;
                        //   }
                        // }
                      },
                    })}
                    accept=".jpg, .jpeg, .png"
                  />
                  {errors.logo && (
                    <span className="text-danger">{errors.logo.message}</span>
                  )}
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field"></Form.Group>
                  <Form.Label>Image</Form.Label>
                  <Form.Control
                    className={classNames("", {
                      "is-invalid": errors?.image,
                    })}
                    type="file"
                    {...register("image", {
                      required: image_required
                        ? "Image is required"
                        : image_required,
                      validate: async (value) => {
                        // if (typeof value !== "string") {
                        //   const fileTypes = ["jpg", "png", "jpeg"];
                        //   const fileType = value[0].name?.split(".")[1];
                        //   if (!fileTypes.includes(fileType)) {
                        //     return `please upload a valid file format. (${fileTypes})`;
                        //   }
                        // }
                      },
                    })}
                    accept=".jpg, .jpeg, .png"
                  />
                  {errors.image && (
                    <span className="text-danger">{errors.image.message}</span>
                  )}
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field"></Form.Group>
                  <Form.Label>Country Logo</Form.Label>
                  <Form.Control
                    className={classNames("", {
                      "is-invalid": errors?.country_logo,
                    })}
                    type="file"
                    {...register("country_logo", {
                      required: country_logo_required
                        ? "Image is required"
                        : country_logo_required,
                      validate: async (value) => {
                        // if (typeof value !== "string") {
                        //   const fileTypes = ["jpg", "png", "jpeg"];
                        //   const fileType = value[0].name?.split(".")[1];
                        //   if (!fileTypes.includes(fileType)) {
                        //     return `please upload a valid file format. (${fileTypes})`;
                        //   }
                        // }
                      },
                    })}
                    accept=".jpg, .jpeg, .png"
                  />
                  {errors.country_logo && (
                    <span className="text-danger">
                      {errors.country_logo.message}
                    </span>
                  )}
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group className="mb-3">
                    <Form.Label className="text-center">
                      Logo Preview
                    </Form.Label>
                    {typeof getValues("logo") == "string" ? (
                      <div className="image-preview-container">
                        <img
                          src={IDS.IMG_URL + getValues("logo")}
                          alt="Preview"
                          className="image-preview"
                          style={{ width: "150px", height: "130px" }}
                        />
                      </div>
                    ) : (
                      logoFile &&
                      logoFile?.length > 0 && (
                        <div className="image-preview-container">
                          <img
                            // src={URL.createObjectURL(getValues("image")[0])}
                            src={URL?.createObjectURL(logoFile[0])}
                            alt="Preview"
                            className="image-preview"
                            style={{ width: "100px", height: "100px" }}
                          />
                        </div>
                      )
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group className="mb-3">
                    <Form.Label className="text-center">
                      Image Preview
                    </Form.Label>
                    {typeof getValues("image") == "string" ? (
                      <div className="image-preview-container">
                        <img
                          src={IDS.IMG_URL + getValues("image")}
                          alt="Preview"
                          className="image-preview"
                          style={{ width: "150px", height: "130px" }}
                        />
                      </div>
                    ) : (
                      imageFile &&
                      imageFile?.length > 0 && (
                        <div className="image-preview-container">
                          <img
                            // src={URL.createObjectURL(getValues("image")[0])}
                            src={URL?.createObjectURL(imageFile[0])}
                            alt="Preview"
                            className="image-preview"
                            style={{ width: "100px", height: "100px" }}
                          />
                        </div>
                      )
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group className="mb-3">
                    <Form.Label className="text-center">
                      Image Preview
                    </Form.Label>
                    {typeof getValues("country_logo") == "string" ? (
                      <div className="image-preview-container">
                        <img
                          src={IDS.IMG_URL + getValues("country_logo")}
                          alt="Preview"
                          className="image-preview"
                          style={{ width: "150px", height: "130px" }}
                        />
                      </div>
                    ) : (
                      countrylogoFile &&
                      countrylogoFile?.length > 0 && (
                        <div className="image-preview-container">
                          <img
                            // src={URL.createObjectURL(getValues("image")[0])}
                            src={URL?.createObjectURL(countrylogoFile[0])}
                            alt="Preview"
                            className="image-preview"
                            style={{ width: "100px", height: "100px" }}
                          />
                        </div>
                      )
                    )}
                  </Form.Group>
                </div>

                {/* Accommodation Status */}
                <div className="col-md-4 mb-3">
                  <Form.Group>
                    <Form.Label>Accommodation Available</Form.Label>
                    <div className="d-flex gap-4">
                      <Form.Check
                        type="radio"
                        label="Yes"
                        value="true"
                        {...register("accomodation_status", {
                          required: "Please select accommodation status",
                        })}
                      />
                      <Form.Check
                        type="radio"
                        label="No"
                        value="false"
                        {...register("accomodation_status")}
                      />
                    </div>
                    {errors.accomodation_status && (
                      <Form.Text className="text-danger">
                        {errors.accomodation_status.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                {/* Conditional Address Fields when Accommodation = Yes */}
                {accomodationStatus === "true" && (
                  <>
                    <div className="col-md-4 mb-3">
                      <Form.Group>
                        <Form.Label>Street</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Street"
                          {...register("street", {
                            required: "Street is required",
                          })}
                          className={classNames({
                            "is-invalid": errors.street,
                          })}
                        />
                        {errors.street && (
                          <Form.Text className="text-danger">
                            {errors.street.message}
                          </Form.Text>
                        )}
                      </Form.Group>
                    </div>

                    <div className="col-md-4 mb-3">
                      <Form.Group>
                        <Form.Label>Postal Code</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Postal Code"
                          {...register("postal_code", {
                            required: "Postal Code is required",
                          })}
                          className={classNames({
                            "is-invalid": errors.postal_code,
                          })}
                        />
                        {errors.postal_code && (
                          <Form.Text className="text-danger">
                            {errors.postal_code.message}
                          </Form.Text>
                        )}
                      </Form.Group>
                    </div>

                    <div className="col-md-4 mb-3">
                      <Form.Group>
                        <Form.Label>City</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter City"
                          {...register("city", {
                            required: "City is required",
                          })}
                          className={classNames({ "is-invalid": errors.city })}
                        />
                        {errors.city && (
                          <Form.Text className="text-danger">
                            {errors.city.message}
                          </Form.Text>
                        )}
                      </Form.Group>
                    </div>

                    <div className="col-md-4 mb-3">
                      <Form.Group>
                        <Form.Label>Country</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Country"
                          {...register("country", {
                            required: "Country is required",
                          })}
                          className={classNames({
                            "is-invalid": errors.country,
                          })}
                        />
                        {errors.country && (
                          <Form.Text className="text-danger">
                            {errors.country.message}
                          </Form.Text>
                        )}
                      </Form.Group>
                    </div>
                  </>
                )}

                {/* Other Boolean Fields */}
                <div className="col-md-4 mb-3">
                  <Form.Group>
                    <Form.Label>Meal Provided</Form.Label>
                    <div className="d-flex gap-4">
                      <Form.Check
                        type="radio"
                        label="Yes"
                        value="true"
                        {...register("meal_provided")}
                      />
                      <Form.Check
                        type="radio"
                        label="No"
                        value="false"
                        {...register("meal_provided")}
                      />
                    </div>
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group>
                    <Form.Label>Uniform Provided</Form.Label>
                    <div className="d-flex gap-4">
                      <Form.Check
                        type="radio"
                        label="Yes"
                        value="true"
                        {...register("uniform_provided")}
                      />
                      <Form.Check
                        type="radio"
                        label="No"
                        value="false"
                        {...register("uniform_provided")}
                      />
                    </div>
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group>
                    <Form.Label>Laundry Service</Form.Label>
                    <div className="d-flex gap-4">
                      <Form.Check
                        type="radio"
                        label="Yes"
                        value="true"
                        {...register("laundry_service")}
                      />
                      <Form.Check
                        type="radio"
                        label="No"
                        value="false"
                        {...register("laundry_service")}
                      />
                    </div>
                  </Form.Group>
                </div>

                {/* Stipend */}
                <div className="col-md-4 mb-3">
                  <Form.Group>
                    <Form.Label>Stipend</Form.Label>
                    <Form.Control
                      type="number"
                      min="0"
                      step="0.01"
                      placeholder="Enter Stipend"
                      {...register("stipend", {
                        required: "Stipend is required",
                      })}
                    />
                    {errors.stipend && (
                      <Form.Text className="text-danger">
                        {errors.stipend.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group>
                    <Form.Label>Start Date</Form.Label>
                    <Form.Control
                      type="date"
                      min={today}
                      {...register("start_date", {
                        required: "Start date is required",
                        validate: (value) =>
                          value >= today || "Start date cannot be in the past",
                      })}
                    />
                    {errors.start_date && (
                      <Form.Text className="text-danger">
                        {errors.start_date.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group>
                    <Form.Label>End Date</Form.Label>
                    <Form.Control
                      type="date"
                      min={startDate || today}
                      {...register("end_date", {
                        required: "End date is required",
                        validate: (value) =>
                          !startDate || value >= startDate
                            ? true
                            : "End date cannot be before start date",
                      })}
                    />
                    {errors.end_date && (
                      <Form.Text className="text-danger">
                        {errors.end_date.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group>
                    <Form.Label>Work Hour (per day)</Form.Label>
                    <Form.Control type="time" {...register("work_hour")} />
                    {errors.work_hour && (
                      <Form.Text className="text-danger">
                        {errors.work_hour.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>
                <div className="col-md-4 mb-3">
                  <Form.Group>
                    <Form.Label>Vacancy</Form.Label>
                    <Form.Control
                      type="number"
                      min="1"
                      placeholder="Enter vacancy"
                      {...register("vacancy")}
                    />
                    {errors.vacancy && (
                      <Form.Text className="text-danger">
                        {errors.vacancy.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                {/* Requirements Multi Select */}
                <div className="col-md-6 mb-3">
                  <Form.Group>
                    <Form.Label>Requirements</Form.Label>
                    <Controller
                      name="requirements"
                      control={control}
                      render={({ field }) => (
                        <Select
                          {...field}
                          isMulti
                          options={internshipRequirement}
                          placeholder="Select requirements"
                        />
                      )}
                    />
                  </Form.Group>
                </div>

                {/* Documents Multi Select */}
                <div className="col-md-6 mb-3">
                  <Form.Group>
                    <Form.Label>Documents Required</Form.Label>
                    <Controller
                      name="documents"
                      control={control}
                      render={({ field }) => (
                        <Select
                          {...field}
                          isMulti
                          options={internshipDocument}
                          placeholder="Select documents"
                        />
                      )}
                    />
                  </Form.Group>
                </div>

                {/* Dynamic Contacts */}
                <div className="col-12 mb-4">
                  <Form.Label className="fw-bold">Contact Persons</Form.Label>
                  {contactFields.map((field, index) => (
                    <div
                      key={field.id}
                      className="row align-items-end mb-3 border p-3 rounded bg-light"
                    >
                      <div className="col-md-3">
                        <Form.Group>
                          <Form.Label>Name</Form.Label>
                          <Form.Control
                            type="text"
                            {...register(`contacts.${index}.name`, {
                              required: "Name required",
                            })}
                          />
                          {errors.contacts?.[index]?.name && (
                            <Form.Text className="text-danger">
                              {errors.contacts[index].name.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </div>
                      <div className="col-md-3">
                        <Form.Group>
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            type="email"
                            {...register(`contacts.${index}.email`, {
                              required: "Email required",
                            })}
                          />
                          {errors.contacts?.[index]?.email && (
                            <Form.Text className="text-danger">
                              {errors.contacts[index].email.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </div>
                      <div className="col-md-2">
                        <Form.Group>
                          <Form.Label>Contact No</Form.Label>
                          <Form.Control
                            type="text"
                            {...register(`contacts.${index}.contact_no`, {
                              required: "Contact required",
                            })}
                          />
                          {errors.contacts?.[index]?.contact_no && (
                            <Form.Text className="text-danger">
                              {errors.contacts[index].contact_no.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </div>
                      <div className="col-md-3">
                        <Form.Group>
                          <Form.Label>Designation / Position</Form.Label>
                          <Form.Control
                            type="text"
                            {...register(`contacts.${index}.designation`, {
                              required: "Designation required",
                            })}
                          />
                          {errors.contacts?.[index]?.designation && (
                            <Form.Text className="text-danger">
                              {errors.contacts[index].designation.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </div>
                      <div className="col-md-1">
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => removeContact(index)}
                        >
                          Remove
                        </Button>
                      </div>
                    </div>
                  ))}
                  <Button
                    variant="blue_border_button btn btn-primary ms-2"
                    onClick={() =>
                      appendContact({
                        name: "",
                        email: "",
                        contact_no: "",
                        designation: "",
                      })
                    }
                  >
                    + Add Contact
                  </Button>
                </div>
              </div>

              <div className="btn_holder mt-4 text-end">
                <Blue_border_button
                  button_text="Save Internship"
                  type="submit"
                />
              </div>
            </Form>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Success_modal
        show={modalSuccessShow}
        onHide={() => setModalsuccessShow(false)}
        message_text="Internship created successfully!"
        animationData={successAnimation}
      />
    </>
  );
}

export default Add_offcanvas;
